import { render, staticRenderFns } from "./ChangeStorage.vue?vue&type=template&id=e371aaa0&"
import script from "./ChangeStorage.vue?vue&type=script&lang=ts&"
export * from "./ChangeStorage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports